import type { TContact } from '@states/softphone/contactSelector';

export function isContactOnCall(contact: Pick<TContact, 'contactId' | 'contactMasterId'>): boolean {
  return contact.contactId != null && contact.contactMasterId != null;
}
